import AppUtils from "@src/utils/appUtils";
import SignolUtils from "@src/utils/signolUtils";

export async function login({ username, password }) {
  const isValid = await SignolUtils.isMockedAuth({ username, password });
  if (!isValid) {
    return Promise.reject(new Error("Invalid username or password"));
  }
  let response = {
    username,
    accessToken: "mockedJWT",
    refreshToken: new Date().getTime(),
  };
  return AppUtils.simulateResponse(response);
}

export function exchangeSSO() {
  let response = {
    accessToken: "mockedJWT",
    refreshToken: "mockedToken",
    username: "vlad@SG.io",
  };
  return AppUtils.simulateResponse(response);
}

export function impersonateLogin({ customerCode, username }) {
  let response = {
    result: true,
    message: "Ok! Mocked impersonated login",
    data: "mockedRefreshedTokens",
    customerCode,
    username,
  };
  return AppUtils.simulateResponse(response);
}

export function impersonateLogout() {
  let response = {
    result: true,
    message: "Logout successfully",
    data: "mockedRefreshedTokens",
  };
  return AppUtils.simulateResponse(response);
}

export function verifyOperatorCode() {
  return AppUtils.simulateResponse({
    result: true,
    data: { customerCode: "SG" },
  });
}

export function verifyEmailAddressInCustomer() {
  return AppUtils.simulateResponse(true);
}

/** Signing up with this customer code simulates a customer whose contract has ended */
export const MOCK_ENDED_CONTRACT_CUSTOMER_CODE = "ENDED";
export const MOCK_ENDED_CONTRACT_CUSTOMER_NAME = "Ended Shipping Ltd";

export function getCustomerStatus(customerCode) {
  const contractEnded = customerCode === MOCK_ENDED_CONTRACT_CUSTOMER_CODE;
  return AppUtils.simulateResponse({
    customerName: contractEnded
      ? MOCK_ENDED_CONTRACT_CUSTOMER_NAME
      : "Signol Demo",
    contractEnded,
  });
}

export async function getMeIdentity(username) {
  return new Promise((resolve) => {
    setTimeout(async () => {
      const data =
        await import("./authObjectMocks/getIdentityProfileResp").then(
          (response) => {
            return response.getIdentityProfileResp[username.toLowerCase()];
          },
        );
      resolve(data);
    }, 10);
  });
}

export function updateMeIdentity() {
  const response = { result: true };
  return AppUtils.simulateResponse(response);
}

export async function getMeIndustry(profile, req) {
  return new Promise((resolve) => {
    setTimeout(async () => {
      const data =
        await import("./authObjectMocks/getIndustryProfileResp").then(
          (response) => {
            return response.getIndustryProfileResp[req];
          },
        );
      resolve(data);
    }, 10);
  });
}

export function getOperatorSecurityQuestion() {
  const response = {
    question: "10 days ago",
    questionOptions: ["A", "B", "C", "D"],
    signature: "answers:::true,false,false,false",
  };
  return AppUtils.simulateResponse(response);
}

export function verifyOperatorSecurityQuestion() {
  const response = { result: true, message: "Correct!" };
  return AppUtils.simulateResponse(response);
}

export function requestForgotPassword() {
  const response = {
    result: true,
    message: "Password forgotten request submitted",
  };
  return AppUtils.simulateResponse(response);
}

export function generateRegistrationLink() {
  const response = { result: true, message: "mocked-registration-token" };
  return AppUtils.simulateResponse(response);
}

export function requestResetPassword() {
  const response = { result: true, message: "Password successfully reset" };
  return AppUtils.simulateResponse(response);
}

export function requestChangePassword() {
  const response = { result: true, message: "Password successfully changed" };
  return AppUtils.simulateResponse(response);
}

export function signup() {
  const response = { result: true, message: "Ok!" };
  return AppUtils.simulateResponse(response);
}

export function requestEmailValidation() {
  const response = { result: true, message: "Email successfully validated" };
  return AppUtils.simulateResponse(response);
}

export function requestAccountValidationWithPassword() {
  const response = { result: true, message: "Account successfully validated" };
  return AppUtils.simulateResponse(response);
}

export function refreshToken() {
  // skip check for specific demo users
  const username = SignolUtils.getCurrentUsername();
  if (!["vlad@sg.io", "chief1234ard"].includes(username)) {
    // if current refresh token is older than 7 days, error out
    if (
      new Date(Number(SignolUtils.getCurrentRefreshToken())) <
      new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000)
    ) {
      return AppUtils.simulateError({ error: "Refresh token expired" });
    }
  } else {
    console.log("skipped check for refresh token expiration");
  }
  let response = {
    accessToken: "mockedJWT",
    refreshToken: SignolUtils.getCurrentRefreshToken(),
  };
  return AppUtils.simulateResponse(response);
}

export function logout() {
  const response = { result: true };
  return AppUtils.simulateResponse(response);
}

export function submitSupport() {
  return AppUtils.simulateResponse(true);
}

export function crewUpdateInternal() {
  return AppUtils.simulateResponse({ result: true });
}
